import { Component } from '@angular/core';
import { AlertController, ModalController } from '@ionic/angular';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { OrdersService } from 'src/app/services/orders.service';

@Component({
  selector: 'app-delete-popup',
  templateUrl: './delete-popup.component.html',
  styleUrls: ['./delete-popup.component.scss'],
})
export class DeletePopupComponent {
  title;
  text;
  buttonText;
  buttonFunction;

  constructor(
    public modalController: ModalController,
    private ordersService: OrdersService,
    private alertController: AlertController
  ) {}

  closeModal() {
    this.modalController.dismiss();
  }

  buttonClicked() {
    if (this.buttonFunction) {
      this.buttonFunction();
    }
    this.closeModal();
  }
}
